// src/push/pushClient.js
const b64ToUint8Array = (base64) => {
  const pad = '='.repeat((4 - (base64.length % 4)) % 4);
  const b64 = (base64 + pad).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(b64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
};

export async function ensureSubscriptionAndSendToBackend({
  vapidPublicKey,
  backendUrl,
  userEmail,
  withCredentials = false,
}) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) {
    throw new Error('Push not supported in this browser');
  }

  // Register SW (idempotent if already registered)
  await navigator.serviceWorker.register('/sw.js');
  const reg = await navigator.serviceWorker.ready;

  // Ask permission (don’t nag if blocked)
  if (Notification.permission === 'default') {
    const perm = await Notification.requestPermission();
    if (perm !== 'granted') throw new Error('Permission denied by user');
  } else if (Notification.permission !== 'granted') {
    throw new Error('Notifications are blocked');
  }

  // Reuse or create a subscription
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: b64ToUint8Array(vapidPublicKey),
    });
  }

  // Send to your backend (shape matches exactly what they want)
  const payload = {
    user_email: userEmail,
    subscription: sub.toJSON(), // { endpoint, expirationTime, keys:{p256dh, auth} }
  };

  const res = await fetch(backendUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: withCredentials ? 'include' : 'omit',
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`Backend save failed: ${res.status} ${text}`);
  }

  return sub;
}

export async function unsubscribePush() {
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) await sub.unsubscribe();
  return true;
}
